































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrderData } from '@/api/types'

@Component({
  name: 'OrderContact'
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IOrderData;

  updatePhoneFormat(e: KeyboardEvent, phone: string): void {
    this.$data[`phoneError${phone}`] = false
    this.$data[`phoneErrorMessage${phone}`] = ''

    const number = parseInt(e.key)
    const isNumber = !isNaN(number)

    const phoneNumberModel = this.value[`contactPhone${phone}`]
    const cleaned = ('' + phoneNumberModel).replace(/\D/g, '')

    if (cleaned.length < 1) {
      return
    }

    if (!isNumber) {
      const phoneRef = this.$refs[`contactPhone${phone}`]
      const element = phoneRef as HTMLInputElement

      // Replace both Model and Input's Value
      element.value = (phoneRef as HTMLInputElement).value.replace(/\D/g, '')
      this.value[`contactPhone${phone}`] = this.value[`contactPhone${phone}`].replace(/\D/g, '')
    }

    const match = cleaned.match(/^(\d{3})$/) || cleaned.match(/^(\d{3})(\d{1,3})$/) || cleaned.match(/^(\d{3})(\d{1,3})(\d{1,4})$/)

    if (cleaned.length > 3) {
      this.value[`contactPhone${phone}`] = '(' + match[1] + ') ' + (match[2] ?? '')
    }

    if (cleaned.length > 6) {
      this.value[`contactPhone${phone}`] = '(' + match[1] + ') ' + (match[2] ?? '') + '-' + (match[3] ?? '')
    }
  }

  resetEmailErrors() {
    this.$data.emailErrorMessage = ''
    this.$data.emailError = false
  }

  resetPhoneErrors(phone: string) {
    this.$data[`phoneError${phone}`] = false
    this.$data[`phoneErrorMessage${phone}`] = ''
  }

  // validatePhoneNumber(phone: string): boolean {
  //   const phoneNumberModel = this.value[`contactPhone${phone}`]

  //   if (phoneNumberModel === '') {
  //     this.$data[`phoneError${phone}`] = false
  //     this.$data[`phoneErrorMessage${phone}`] = ''
  //     return true
  //   }

  //   const cleaned = ('' + phoneNumberModel).replace(/\D/g, '')
  //   const isPhoneNumber = /^\d+$/.test(cleaned) && cleaned.length === 10

  //   this.$data[`phoneError${phone}`] = !isPhoneNumber
  //   this.$data[`phoneErrorMessage${phone}`] = !isPhoneNumber ? 'Invalid Phone number' : ''

  //   return this.$data[`phoneError${phone}`]
  // }

  // validateEmail(): void {
  //   if (!this.value.Email) {
  //     this.$data.emailError = false
  //     return
  //   }

  //   const validEmailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/
  //   const result = this.value.Email.match(validEmailRegex)

  //   if (!result) {
  //     this.$data.emailError = true
  //     this.$data.emailErrorMessage = 'Invalid Email address'
  //   }
  // }
}
